import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareRoadmapRedirectRoute: InvariantJiraRoute = {
	name: 'software-roadmap-redirect',
	path: '/secure/Roadmap.jspa',
};
